import { jsx } from '@emotion/core';
import uniqueId from 'lodash/uniqueId';
import { Context } from './context';
import { wrapperStyles } from './styles';
import { Item } from './item';

var ButtonToggle = function ButtonToggle(_a) {
  var children = _a.children,
      _b = _a.size,
      size = _b === void 0 ? 'medium' : _b,
      _c = _a.selectedValue,
      selectedValue = _c === void 0 ? '' : _c,
      onChange = _a.onChange,
      _d = _a.disabled,
      disabled = _d === void 0 ? false : _d;
  var name = uniqueId('button-toggle');
  return jsx(Context.Provider, {
    value: {
      size: size,
      selectedValue: selectedValue,
      onChange: onChange,
      disabled: disabled,
      name: name
    }
  }, jsx("div", {
    css: wrapperStyles
  }, children));
};

ButtonToggle.Item = Item;
export default ButtonToggle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/ButtonToggle/index.js
// module id = 1234
// module chunks = 0